import {
  DELETE_ITEM,
  ITEM_TO_BAG,
  UPDATE_ITEM,
  LOAD_ITEMS,
  SORT_INTENT,
  SIZE_SELECT_ERROR
} from "../../../../../state/modules/savedItems/constants";
import { SET_ITEM_SAVED_STATUS } from "../../../../../state/modules/common/constants";
import content from "app-content";
import isAppOnline from "../../../../../providers/applicationOnlineStatusProvider";
import getItemToBagErrorMessage from "../../../common/DismissibleErrorBanner/getErrorMessage/getItemToBagErrorMessage";

const actionTypeToErrorMessageMap = {
  [DELETE_ITEM]: () => content.saved_items_deletion_failure_message,
  [ITEM_TO_BAG]: ({ errorCode, errorMessage }) =>
    getItemToBagErrorMessage({
      errorCode,
      errorMessage
    }),
  [UPDATE_ITEM]: () => content.saved_items_update_sizecolour_fail,
  [SET_ITEM_SAVED_STATUS]: () =>
    content.share_board_add_to_saved_generic_failure,
  [LOAD_ITEMS]: () => content.saved_items_page_load_error_transient,
  [SORT_INTENT]: () => content.saved_items_page_load_error_transient,
  [SIZE_SELECT_ERROR]: () => content.back_in_stock_select_size_prompt
};

export default ({ common: { errors } }) => {
  const mostRecentError = errors[errors.length - 1];
  if (mostRecentError) {
    if (!isAppOnline()) {
      return content.saved_items_no_internet_connection_message;
    }

    const { type, payload } = mostRecentError;

    return actionTypeToErrorMessageMap[type](payload);
  }
};
